<template>
  <div id="header-box">
    <v-app>
      <v-app-bar>
        <v-menu
          transition="slide-x-transition"
          style="width: 200px"
          offset-x="10"
        >
          <template #activator="{ props }">
            <v-btn v-bind="props">
              <v-app-bar-nav-icon />
            </v-btn>
          </template>
          <v-list>
            <v-list-item min-width="250px">
              <v-list-item-title>
                <a href="/stylists">Manage Stylists </a>
              </v-list-item-title>
            </v-list-item>
            <v-list-item min-width="250px">
              <v-list-item-title>
                <a href="/merge">Merge Clients </a>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <a href="/logout">Logout</a>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-app-bar-title style="font-size: 16px"
          >SS Hair Calendar</v-app-bar-title
        >
        <div class="v-btn-box">
          <v-btn variant="outlined" @click="showToday">Today</v-btn>
        </div>
        <div class="date-picker-box">
          <DatePicker v-model="currentDate">
            <template #default="{ togglePopover }">
              <v-btn icon="mdi-chevron-left" @click="prev"></v-btn>
              <span id="header-date-box">{{ formatedDate }}</span>
              <v-btn icon="mdi-chevron-right" @click="next"></v-btn>
              <v-btn
                style="display: none"
                icon="mdi-menu-down"
                @click="togglePopover"
              ></v-btn>
            </template>
          </DatePicker>
        </div>
        <div class="titleBox">{{ page_title }}</div>
        <div class="settings-select-box">
          <v-menu
            v-model="barSearch.isShowSearch"
            :close-on-content-click="false"
          >
            <template #activator="{ props }">
              <v-btn variant="outlined" @click="setSearchBox()" v-bind="props"
                >Search</v-btn
              >
            </template>
            <SearchNotesBox
              v-if="barSearch.isNotesSearch"
              @toggle-addnote="switchAddNoteBox"
            />
            <SearchAddNotes
              v-if="!barSearch.isNotesSearch"
              :event="eventStore.getEvent(barSearch.notesEventId)"
              :customer-id="customer_id"
            />
          </v-menu>
          <div class="fx-item-1"></div>
          <div class="fx-item-2">
            <v-select
              v-model="appointmentStore.calendarView"
              :items="selectItems"
              density="compact"
              variant="outlined"
            >
            </v-select>
          </div>
        </div>
      </v-app-bar>
    </v-app>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import { format, utcToZonedTime } from "date-fns-tz";
import { useDateStore } from "../stores/datestore.js";
import { useAppointmentStore } from "../stores/appointmentsStore";
import { watch } from "vue";
import { useEventStore } from "../stores/EventStore";

import SearchNotesBox from "./search/SearchNotes.vue";
import SearchAddNotes from "./search/AddNotes.vue";
import { storeToRefs } from "pinia";

export default {
  name: "HeaderBar",
  components: {
    DatePicker,
    SearchNotesBox,
    SearchAddNotes,
  },
  setup() {
    //use of currentDate as the store name has created a glitch,
    // we have to use the currentDate variable to access store variables
    // wehre as it should have been dateStore
    const currentDate = new useDateStore();
    const appointmentStore = new useAppointmentStore();
    const eventStore = new useEventStore();
    const { barSearch } = storeToRefs(appointmentStore);

    watch(
      () => appointmentStore.calendarView,
      () => {
        if (appointmentStore.calendarView === "Day")
          currentDate.$patch({ duration: 0 });
        if (appointmentStore.calendarView === "Week")
          currentDate.$patch({ duration: 6 });
      }
    );
    return {
      currentDate,
      appointmentStore,
      barSearch,
      eventStore,
    };
  },
  data() {
    return {
      selectItems: ["Day", "Week"],
      notes: [],
      event: {},
      customer_id: null,
    };
  },
  computed: {
    formatedDate() {
      let utcZonedTime = utcToZonedTime(this.currentDate.selectedDate, "UTC");
      return format(utcZonedTime, "E MMMM d, yyyy", "UTC");
    },
    page_title() {
      let indi = document.title.search("([0-9]|[1-9])");
      return document.title
        .slice(indi + 2)
        .replaceAll("_", " ")
        .trim();
    },
    name() {
      return this.event.customer.firstname + " " + this.event.customer.lastname;
    },
  },
  methods: {
    next() {
      this.currentDate.addOneDay();
    },
    prev() {
      this.currentDate.subtractOneDay();
    },
    showToday() {
      this.currentDate.today();
    },
    setSearchBox() {
      this.appointmentStore.$patch({
        barSearch: {
          isNotesSearch: true,
          notesEventId: null,
        },
      });
    },
    switchAddNoteBox(customerId) {
      this.barSearch.isNotesSearch = !this.barSearch.isNotesSearch;
      this.customer_id = customerId;
      this.appointmentStore.from_dropdown = true;
    },
  },
};
</script>

<style scoped>
#header-box {
  height: 66px;
}
.v-toolbar.v-toolbar--density-default.v-app-bar {
  box-shadow: none;
  border-bottom: 1px solid lightgrey;
}
.v-btn-box {
  flex: 1 1 0;
}

.v-btn-box > button {
  font-size: 14px;
  text-transform: none;
}

.date-picker-box {
  flex: 2 0 0;
  text-align: left;
  font-size: 1.3rem;
}

.titleBox {
  flex: 1 1 0;
  text-align: left;
  font-size: 1.3rem;
}

.settings-select-box {
  flex: 1 0 0;
  display: inline-flex;
  align-items: center;
}

.settings-select-box .v-field__input {
  padding: 0px !important;
}

.fx-item-1 {
  flex: 1 1 0;
}

.fx-item-2 {
  flex: 2 1 0;
  align-items: center;
  height: 45px;
  margin-right: 30px;
}

.v-btn--variant-outlined {
  border: thin solid rgb(218, 220, 224);
}

#header-date-box {
  display: inline-block;
  min-width: 200px;
  text-align: center;
}
</style>
